/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export enum ImbalanceFilter {
  WMS_ZERO = "WMS_ZERO",
  WMS_LESS_THAN_CI = "WMS_LESS_THAN_CI",
  WMS_MORE_THAN_CI = "WMS_MORE_THAN_CI",
}


export type ImbalanceConnection = {
  __typename: "ImbalanceConnection",
  items?:  Array<Imbalance | null > | null,
  nextToken?: string | null,
  totalCount?: number | null,
};

export type Imbalance = {
  __typename: "Imbalance",
  material?: string | null,
  size?: string | null,
  quality?: string | null,
  coo?: string | null,
  wmsQty?: number | null,
  ciBondedQty?: number | null,
  ciNonBondedQty?: number | null,
  ciTotalQty?: number | null,
  imbalance?: number | null,
  persistentImbalance?: number | null,
  persistent1m?: number | null,
  persistent2m?: number | null,
  persistent3m?: number | null,
  persistent4m?: number | null,
  persistent6m?: number | null,
  persistent12m?: number | null,
  direction?: string | null,
  cleanStatus?: string | null,
  flowInformation?: string | null,
};

export type GetImbalancesQueryVariables = {
  material?: string | null,
  size?: string | null,
  month: string,
  filter?: ImbalanceFilter | null,
  isPersistent?: boolean | null,
  excludeColors?: boolean | null,
  nextToken?: string | null,
};

export type GetImbalancesQuery = {
  getImbalances?:  {
    __typename: "ImbalanceConnection",
    items?:  Array< {
      __typename: "Imbalance",
      material?: string | null,
      size?: string | null,
      quality?: string | null,
      coo?: string | null,
      wmsQty?: number | null,
      ciBondedQty?: number | null,
      ciNonBondedQty?: number | null,
      ciTotalQty?: number | null,
      imbalance?: number | null,
      persistentImbalance?: number | null,
      persistent1m?: number | null,
      persistent2m?: number | null,
      persistent3m?: number | null,
      persistent4m?: number | null,
      persistent6m?: number | null,
      persistent12m?: number | null,
      direction?: string | null,
      cleanStatus?: string | null,
      flowInformation?: string | null,
    } | null > | null,
    nextToken?: string | null,
    totalCount?: number | null,
  } | null,
};
